import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr, inrCompact, num } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { KpiCard } from "@/components/KpiCard";
import { ChartCard, Bars } from "@/components/Charts";
import { Building2, Users, Package, IndianRupee, Wallet, CheckCircle } from "lucide-react";

export default function FranchiseDashboard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/franchise/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div>
      <PageHeader title="Franchise Dashboard" subtitle="Franchise partner network performance & earnings" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard testId="fd-total" label="Franchise Partners" value={num(d.total_franchise)} icon={Building2} accent="violet" sub={`${d.active_franchise} active`} />
        <KpiCard testId="fd-dp" label="Delivery Partners" value={num(d.total_dp)} icon={Users} accent="primary" />
        <KpiCard testId="fd-orders" label="Total Orders" value={num(d.total_orders)} icon={Package} accent="cyan" sub={`${num(d.today_orders)} today`} />
        <KpiCard testId="fd-earn" label="Franchise Earnings" value={inrCompact(d.total_earning)} icon={IndianRupee} accent="emerald" />
        <KpiCard testId="fd-week" label="Weekly Orders" value={num(d.week_orders)} icon={Package} accent="primary" />
        <KpiCard testId="fd-month" label="Monthly Orders" value={num(d.month_orders)} icon={Package} accent="primary" />
        <KpiCard testId="fd-pending" label="Pending Payout" value={inrCompact(d.pending_payout)} icon={Wallet} accent="amber" />
        <KpiCard testId="fd-paid" label="Paid Amount" value={inrCompact(d.paid_amount)} icon={CheckCircle} accent="emerald" />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <ChartCard title="Top Franchise Partners" subtitle="By total earnings">
          <Bars data={d.top.map((t) => ({ name: t.name, earnings: t.earnings }))} x="name" y="earnings" color="#8B5CF6" horizontal height={300} />
        </ChartCard>
        <div className="rounded-xl border border-border bg-card p-5">
          <h3 className="font-head text-sm font-semibold mb-3">Leaderboard</h3>
          <div className="space-y-2">
            {d.top.map((t) => (
              <button key={t.id} onClick={() => nav(`/franchise/${t.id}`)} data-testid={`fd-top-${t.rank}`} className="flex w-full items-center gap-3 rounded-lg border border-border bg-secondary/40 p-2.5 text-left transition hover:border-primary/40">
                <span className={`flex h-8 w-8 items-center justify-center rounded-full font-head text-sm font-bold ${t.rank <= 3 ? "bg-amber-500/20 text-amber-500" : "bg-muted text-muted-foreground"}`}>{t.rank}</span>
                <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold">{t.name}</p><p className="text-xs text-muted-foreground font-mono">{t.referral} · {num(t.orders)} orders · {t.active_dp} DPs</p></div>
                <span className="tabular text-sm font-semibold text-emerald-500">{inrCompact(t.earnings)}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
